import Axios from './baseApi'

export default {
  async create(data) {
    return await Axios.put('/api-master-data/v1/contact', data);
  },
  async update(id, data) {
    return await Axios.post('/api-master-data/v1/contact/' + id, data);
  },
  async delete(id) {
    return await Axios.delete('/api-master-data/v1/contact/' + id);
  }
}
